import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-white-box',
  templateUrl: './white-box.component.html',
  styleUrls: ['./white-box.component.scss']
})
export class WhiteBoxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
